export default "__VITE_ASSET__ChSuBGLU__"